/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Triangle_Copy': {
    width: 17,
    height: 36,
    viewBox: '0 0 17 36',
    data: '<path pid="0" d="M17 17.971L0-.019l12.852 17.99L0 35.961z" _fill="#CB242A" fill-rule="evenodd"/>'
  }
})
